import React, { useEffect, useState } from "react";
import Headr from "../../components/ipillion/Headr";
import Auctions from "../../components/ipillion/Auctions";
import Why_iPillion from "../../components/ipillion/Why_iPillion";
import Auctions_slider from "../../components/ipillion/Auctions_slider";
import Phone from "../../components/ipillion/Phone";
import Facts from "../../components/ipillion/Facts";
import Platforms from "../../components/ipillion/Platforms";
import Community from "../../components/projects/sharedSections/Community";
import Window from "../../components/assets/ipillion/Window";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import TechSlider from "../../components/projects/ipillion/sections/TechSlider";
import ProjectsComp from "../../components/projects";
import axios from "axios";
import SectionTitle from "../../components/SectionTitle";
import Head from "next/head";
export default function ipillion({}) {
  const t = useTranslations("ipillion.Auctions");
  const router = useRouter();
  const [lang, setLang] = useState(router.locale);
  const [allProjects, setAllProjects] = useState([]);
  useEffect(() => {
    axios
      .get(`${process.env.NEXT_APP_BACKEND_URL}user/project/all-Project`)
      .then((res) => {
        setAllProjects(res.data.result.slice(1));
      })
      .catch((err) => {});
    setLang(router.locale);
  }, []);

  return (
    <>
      <Head>
        <title>Ascot - iPillion</title>
      </Head>
      <div className="bg-[#F2F2F2]">
        <div className="relative z-0">
          <Headr />
        </div>
        <div className="max-w-[90rem] m-auto responsive mt-10 ">
          <Auctions
            text={t("text")}
            icon={<Window />}
            color={"#D60014"}
            link={"/services/64070961703e2f89a5b9ba35"}
          />
          <Why_iPillion />
          <Auctions_slider />
          <Phone />
        </div>
        <div className=" mb-14">
          <TechSlider lang={lang} />
        </div>
        <Platforms />
        {/* <div className="max-w-[90rem] m-auto responsive ">
          <Facts lang={lang} />
        </div> */}

        <Community color={"#D60014"} />
        <div className="py-24">
          <SectionTitle title={t("discover")} />
          <ProjectsComp data={allProjects} />
        </div>
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  try {
    return {
      props: {
        messages: require(`../../locales/${context.locale}.json`),
      },
    };
  } catch (error) {
    return { props: { blogData: false } };
  }
}
